import { DataViewerUtil } from '@leverege/molten/data-viewers'
import { ItemCard } from '@leverege/ui-attributes'
import { Content, Pane, Text } from '@leverege/ui-elements'
import { Toolbar } from '@leverege/ui-plugin'
import React from 'react'

import S from './AisleHeatmappingCards.css'

export default function AisleHeatmapping( props ) {
  const {
    paginator,
    settings : model,
    objectType,
    relationship,
    inCard,
  } = props

  const { path } = relationship

  const actionBarMatchContext = {
    use : 'actionBar',
    client : AisleHeatmapping.CLIENT,
    objectType,
    path,
  }

  const context = {
    client : AisleHeatmapping.CLIENT,
    clientProps : props,
  }

  const content = (
    <Toolbar
      className={S.toolbar}
      variant="actionBar"
      prefer="icon"
      matchContext={actionBarMatchContext}
      context={context}/>
  )

  return (
    <Content className={S.content} relative>
      <Content.Header layout="flex:rowMEnd">
        <DataViewerUtil.HeaderToolbar inCard={inCard} content={content} />
      </Content.Header>
      <Content.Area>
        <Pane variant="roomGrid" className={S.aisles}>
          {paginator.pageItems.map( item => (
            <ItemCard
              key={item.id}
              model={model}
              variant="customItemContent"
              context={{
                id : item.id,
                target : [ item ],
              }}/>
          ) )}
        </Pane>
      </Content.Area>
    </Content>
  )
}

export function Occupancy( { item } ) {
  const counts = Object.values( item?.data?.data?.occupancy ).reduce( ( acc, curr ) => ( {
    dog : acc.dog + ( curr?.counts?.dog ?? 0 ),
    person : acc.person + ( curr?.counts?.person ?? 0 )
  } ), { dog : 0, person : 0 } )

  const dog = counts.dog
  const person = counts.person
  
  const limit = item?.data?.data?.petOccupancyCapacity
  const empty = !dog && !person
  const over = dog > limit
  const unattended = dog > 0 && !person
  const variant = empty ? 'pillEmpty' : over ? 'pillAlert' : 'pillWarning'
  const text = empty ?
    'Empty' :
    over ?
      'Over Capacity' :
      unattended ?
        'Unattended' :
        ''

  return <Text variant={text && variant}>{text}</Text>
}

AisleHeatmapping.CLIENT = 'AisleCardDataViewer'
